import { MemberFirearmDTO } from '../../services/apiClient';
import { TableAction } from '../common/Table';
import { CalendarCheck, Check, Download, RotateCcw, Search, Send, Target, Trash2 } from 'lucide-react';

interface MemberFiremarmsActionHandlers {
  onDownloadPostalTarget: (memberFirearm: MemberFirearmDTO) => void;
  onSubmitPostalTarget: (memberFirearm: MemberFirearmDTO) => void;
  onDownloadActivityTarget: (memberFirearm: MemberFirearmDTO) => void;
  onSubmitActivityTarget: (memberFirearm: MemberFirearmDTO) => void;
  onDelete: (memberFirearm: MemberFirearmDTO) => Promise<void>;
  onRestore: (memberFirearm: MemberFirearmDTO) => Promise<void>;
}

const createMemberFirearmActions =
  (handlers: MemberFiremarmsActionHandlers) =>
  (row: MemberFirearmDTO): TableAction[] => {
    const actions: TableAction[] = [];

    if (handlers.onDownloadPostalTarget) {
      actions.push({
        label: 'Download Postal Targets',
        onClick: () => handlers.onDownloadPostalTarget(row),
        icon: <Download className="w-4 h-4" />,
      });
    }

    if (handlers.onSubmitPostalTarget) {
      actions.push({
        label: 'Submit a Postal Target',
        onClick: () => handlers.onSubmitPostalTarget(row),
        icon: <Target className="w-4 h-4" />,
      });
    }

    if (handlers.onDownloadActivityTarget) {
      actions.push({
        label: 'Download Activity Targets',
        onClick: () => handlers.onDownloadActivityTarget(row),
        icon: <Download className="w-4 h-4" />,
      });
    }

    if (handlers.onSubmitActivityTarget) {
      actions.push({
        label: 'Submit a Activity Target',
        onClick: () => handlers.onSubmitActivityTarget(row),
        icon: <CalendarCheck className="w-4 h-4" />,
      });
    }

    if (row.isDeleted) {
      actions.push({
        label: 'Restore Deleted',
        onClick: () => handlers.onRestore(row),
        icon: <RotateCcw className="w-4 h-4" />,
        confirmMessage: 'Are you sure you want to restore this member firearm?',
        className: 'text-green-600 hover:text-green-700',
      });
    } else {
      actions.push({
        label: 'Delete MemberFirearm',
        onClick: () => handlers.onDelete(row),
        icon: <Trash2 className="w-4 h-4" />,
        confirmMessage: 'Are you sure you want to delete this member firearm?',
        className: 'text-red-600 hover:text-red-700',
      });
    }

    return actions;
  };

export default createMemberFirearmActions;
